import form from "./schemas/form";
import validations from "./schemas/validations";
import {useEffect, useState} from "react";
import initialValues from "./schemas/initialValues";
import axios from "axios";
import {API_URL} from "../../../config";
import {capitalizeFirstLetter} from "../../../helpers/helpers";
import {useParams} from 'react-router-dom';
import {getUserService, updateUserService} from "../../../services/userService";

const useEditUser = () => {

    const { id } = useParams();

    const {formId, formField} = form;
    const currentValidation = validations;

    const [values, setValues] = useState(initialValues);

    const [isLoading, setIsLoading] = useState(true);

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });
    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    useEffect(() => {

        const init = async () => {

            setIsLoading(true);

            await loadRecord();

            setIsLoading(false);
        };

        init();

    }, []);

    const loadRecord = async () => {

        try {

            const response = await getUserService(id);

            setValues(response.data.data);

        } catch (error) {

            setSnackbarConfig({
                message: "Ocurrió un error cargando el perfil",
                icon: 'cancel',
                title: 'Usuarios',
                color: 'warning'
            });

            setShow(true);

        }

    };

    const handleSubmit = async (values, actions) => {

        try {

            // Make a copy of values so we aren't mutating the object directly
            let submitValues = {...values};

            // Check if the password field is empty and, if so, delete the password and password_confirmation fields
            if(values.password === "") {
                delete submitValues.password;
                delete submitValues.password_confirmation;
            }

            // Enviar datos a API
            await updateUserService(id, values)

            setSnackbarConfig({
                message: 'Usuario actualizado exitosamente',
                icon: 'notifications',
                title: 'Usuarios',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Usuarios',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return {
        formId,
        formField,
        currentValidation,
        values,
        isLoading,
        snackbarConfig,
        show,
        toggleSnackbar,
        handleSubmit
    }
};

export default useEditUser;
